/* RESPONSIBLE TEAM: team-automation-foundations */
import Controller from '@ember/controller';

export default class WorkflowsTroubleshootConversationsWithIdController extends Controller {
  queryParams = ['eventTypes', 'status'];
}
